import { AuthGuard } from "../../auth/helpers";
import { FormAddCollaboratorComponent } from "./pages/form-add-collaborator/form-add-collaborator.component";
import { FormEditCollaboratorComponent } from "./pages/form-edit-collaborator/form-edit-collaborator.component";
import { ListCollaboratorsComponent } from "./pages/list-collaborators/list-collaborators.component";
import { ExEmployeesListComponent } from "../../pages/dashboard/user/ex-employees-list/ex-employees-list.component";
import { EditMyProfileCollaboratorComponent } from "./pages/edit-my-profile-collaborator/edit-my-profile-collaborator.component";
import { TransformationListComponent } from "./pages/transformation-collaborator/trasformation-list/transformation-list.component";
import { EditTransformationComponent } from "./pages/transformation-collaborator/edit-trasformation/edit-transformation.component";
import { CreateTransformationComponent } from "./pages/transformation-collaborator/create-trasformation/create-transformation.component";
import { TransformationSelectComponent } from "./pages/transformation-collaborator/transformation-select/transformation-select.component";
import { IRoute } from "app/auth/models/utils-interfaces";
import { CollaboratorsCostsComponent } from "./pages/collaborators-costs/collaborators-costs.component";

const collaboratorsRoutes: IRoute[] = [
  //Form add collaboratore
  {
    path: "dashboard/collaborators/add",
    component: FormAddCollaboratorComponent,
    canActivate: [AuthGuard],
  },
  //Form edit collaboratore
  {
    path: "dashboard/collaborators/edit/:hash",
    component: FormEditCollaboratorComponent,
    canActivate: [AuthGuard],
  },
  //Lista collaboratori
  {
    path: "dashboard/collaborators/list",
    component: ListCollaboratorsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "dashboard/ex-employees/list",
    component: ExEmployeesListComponent,
    canActivate: [AuthGuard],
  },
  //Form edit my profile collaboratore
  {
    path: "dashboard/collaborator/edit-profile/:user_identifier",
    component: EditMyProfileCollaboratorComponent,
    canActivate: [AuthGuard],
  },
  //Trasformazioni modifica
  {
    path: "dashboard/collaborator/costs",
    component: CollaboratorsCostsComponent,
    canActivate: [AuthGuard],
  },
  //Trasformazioni lista
  {
    path: "dashboard/transformation-list",
    component: TransformationListComponent,
    canActivate: [AuthGuard],
  },
  //Trasformazioni select
  {
    path: "dashboard/transformation-select",
    component: TransformationSelectComponent,
    canActivate: [AuthGuard],
  },
  //Trasformazioni crea
  {
    path: "dashboard/transformation-create/:user_identifier",
    component: CreateTransformationComponent,
    canActivate: [AuthGuard],
  },
  //Trasformazioni modifica
  {
    path: "dashboard/transformation-edit/:id",
    component: EditTransformationComponent,
    canActivate: [AuthGuard],
  },
];
export default collaboratorsRoutes;
